// eslint-disable-next-line  @typescript-eslint/no-explicit-any
const set = (o: any, key: string, value: any) => {
  if (value) {
    o[key] = value
  }
}
export default set
